/*
 * Copyright (c) 2025, Glasswing AI, Inc.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 * Glasswing AI, Inc. ("Confidential Information").
 * You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Glasswing AI, Inc.
 */
import { Container, Row, Col, Stack } from 'react-bootstrap';
import { Table, Badge } from 'react-bootstrap';
import dayjs from 'dayjs'

function ProbeDetailTcp({ data }) {
    const detail = data?.detail || {};
    const activity = Array.isArray(detail.activity) ? detail.activity : [];
    const activityWithDelta = (() => {
        let lastTs = 0;
        return activity.map((ent: any) => {
            const ts = Number(ent?.ts || 0);
            const delta = lastTs ? (ts - lastTs) : 0;
            lastTs = ts || lastTs;
            return { ...ent, ts, delta };
        });
    })();

  return (
    <Container fluid>
        <Row>
            <Col>
                <h2>Address: {detail.addr}:{detail.port}</h2>
            </Col>
        </Row>
        <Row>
            <Col>
                <Table borderless>
                    <thead>
                        <tr>
                            <th>Ts</th>
                            <th>Delta</th>
                            <th>Activity</th>
                        </tr>
                    </thead>
                    <tbody>
                        {activityWithDelta.map((e: any, idx: number) => {
                            return (
                                <tr key={idx}>
                                    <td>{dayjs(e.ts).format('YYYY-MM-DD HH:mm:ss')}</td>
                                    <td>{e.delta ? e.delta : 0} ms</td>
                                    <td>{e.msg}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </Col>
        </Row>
    </Container>
  );
}

export default ProbeDetailTcp;